var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManutencao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.935,
    height: 20,
    viewBox: "0 0 19.935 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 19.935,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.935,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M11.40200806 8.09899902l8.25898742 8.26000977c.17501831.16723633.27433777.39855957.27510071.640625.00074768.24209595-.09713745.47402954-.27108765.6423645l-2.0920105 2.0920105c-.16996764.17044067-.40078735.26620483-.64149474.26620483-.2407074 0-.4715271-.09576416-.64149476-.26620483L8.0019989 11.4460144c-2.4455719.93685914-5.21601868.14950562-6.80337524-1.9335022-1.58734131-2.08297729-1.61161804-4.9630432-.0596161-7.07250976L4.6230011 5.92401123l1.29200744-1.28500366-3.49301147-3.5C4.54899597-.41830444 7.45019531-.3786316 9.53379822 1.2362976c2.08358764 1.61489868 2.84571838 4.41448974 1.86820984 6.86270141zm-3.07600403 1.1090088l8.6060028 8.60699462.80499268-.80801391-8.59999084-8.5999756c.4115448-.51812743.68659973-1.13113402.80000305-1.78302001.22026062-1.230896-.13580322-2.49487305-.96620178-3.42977905-.83039856-.93493653-2.04350281-1.4376831-3.29180909-1.3642273L8.4900055 4.6419983 4.6320038 8.49899292 1.82099914 5.69198608c-.06835938 1.22692871.41975402 2.41931153 1.32879638 3.24612427.90905762.82678223 2.14227295 1.19995117 3.35720825 1.01589966.65919495-.09255981 1.28463746-.34906006 1.81900025-.7460022z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManutencao);
export default __webpack_public_path__ + "static/media/manutencao.e724c98c1ad5fd3e7936e58e468cb6ae.svg";
export { ForwardRef as ReactComponent };